"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rest_api_1 = require("@nimles/rest-api");

var actionTypes_1 = require("../actionTypes");

var actionCreator_1 = require("../../utils/actionCreator");

exports.loadTexts = function (queryParameters) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.LOAD_TEXTS
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.getTexts(auth, queryParameters);
  });
};

exports.loadText = function (id) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.LOAD_TEXT,
    id: id
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.getText(auth, id);
  });
};

exports.createText = function (data) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.CREATE_TEXT
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.postText(auth, data);
  });
};

exports.updateText = function (data) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.UPDATE_TEXT
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.putText(auth, data);
  });
};

exports.deleteText = function (id) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.DELETE_TEXT
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.delText(auth, id);
  });
};

exports.addTextPermission = function (id, permission) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.ADD_TEXT_PERMISSION,
    id: id
  }, function (_a) {
    var auth = _a.auth;
    return __awaiter(void 0, void 0, void 0, function () {
      var response;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4
            /*yield*/
            , rest_api_1.postTextPermission(auth, id, permission)];

          case 1:
            response = _b.sent();
            return [2
            /*return*/
            , {
              data: __assign(__assign({}, permission), {
                id: response.data.fields['permissionId']
              })
            }];
        }
      });
    });
  });
};

exports.removeTextPermission = function (id, permissionId) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.REMOVE_TEXT_PERMISSION,
    id: id
  }, function (_a) {
    var auth = _a.auth;
    return __awaiter(void 0, void 0, void 0, function () {
      var response;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4
            /*yield*/
            , rest_api_1.deleteTextPermission(auth, id, permissionId)];

          case 1:
            response = _b.sent();
            return [2
            /*return*/
            , {
              data: permissionId
            }];
        }
      });
    });
  });
};

exports.setTextAccessibility = function (id, accessibility) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.SET_TEXT_ACCESSIBILITY
  }, function (_a) {
    var auth = _a.auth;
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4
            /*yield*/
            , rest_api_1.putTextAccessibility(auth, id, accessibility)];

          case 1:
            _b.sent();

            return [2
            /*return*/
            , {
              id: id,
              data: accessibility
            }];
        }
      });
    });
  });
};

exports.setTextOrganization = function (id, organizationId) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.SET_TEXT_ORGANIZATION
  }, function (_a) {
    var auth = _a.auth;
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4
            /*yield*/
            , rest_api_1.putTextOrganization(auth, id, organizationId)];

          case 1:
            _b.sent();

            return [2
            /*return*/
            , {
              id: id,
              data: organizationId
            }];
        }
      });
    });
  });
};

exports.addTextRelation = function (id, relation) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.ADD_TEXT_RELATION
  }, function (_a) {
    var auth = _a.auth;
    return __awaiter(void 0, void 0, void 0, function () {
      var response;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4
            /*yield*/
            , rest_api_1.postTextRelation(auth, id, relation)];

          case 1:
            response = _b.sent();
            return [2
            /*return*/
            , {
              id: id,
              data: __assign(__assign({}, relation), {
                id: response.fields['relationId']
              })
            }];
        }
      });
    });
  });
};

exports.removeTextRelation = function (id, relationId) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.REMOVE_TEXT_RELATION
  }, function (_a) {
    var auth = _a.auth;
    return __awaiter(void 0, void 0, void 0, function () {
      var response;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4
            /*yield*/
            , rest_api_1.deleteTextRelation(auth, id, relationId)];

          case 1:
            response = _b.sent();
            return [2
            /*return*/
            , {
              id: id,
              data: relationId
            }];
        }
      });
    });
  });
};